export default __webpack_public_path__ + "static/pricingLanding-a6c630df760e2674e2d97df7321ec4da.png";